import { Loadable } from 'foundations-components/transitional/utils/Loadable';

import AsyncComponentErrorHandler from 'framework-listing-lib/internal/shared/components/AsyncComponentErrorHandler';

import type ListingLibDevTools from './ListingLibDevTools';

export default Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "listing-lib-dev-tools" */ './ListingLibDevTools'
    )
      .then((mod) => mod.default)
      .catch(AsyncComponentErrorHandler('listing-lib-dev-tools')),
  LoadingComponent: () => null,
}) as unknown as typeof ListingLibDevTools;
